import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { camelCase } from '../scripts/string-manipulators';

type ComponentProps = {
  [key: string]: any,
}

type DynamicLoaderProps = {
  pageId: string,
}

const Components: ComponentProps = {
  portfolio: lazy(() => import('./projects/portfolio')),
  mspot: lazy(() => import('./projects/mspot')),
  mazePainter: lazy(() => import('./projects/maze-painter')),
};

const DynamicLoader = ({ pageId }: DynamicLoaderProps) => {
  console.log(pageId);
  const Component = Components[camelCase(pageId)];

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component />
    </Suspense>
  );
};

const ProjectsLoader = () => {
  const { id } = useParams();

  if (!id) return null;

  return (
    <DynamicLoader pageId={id} />
  );
};

export default ProjectsLoader;
